import { useEffect, useRef } from 'react';

const EMOJIS: string[] = [
  '😀','😁','😂','🤣','😊','😉','😍','😘',
  '😎','🤔','😴','😅','😇','🙂','🙃','😋',
  '😢','😭','😡','😱','😳','🥺','🤯','😮',
  '👍','👎','👏','🙏','💪','🤝','👌','✌️',
  '❤️','💔','💖','💯','✨','🔥','⭐','🎉',
  '✅','❌','⚠️','❓','❗','💡','📌','📎',
  '📞','📧','💬','🛒','💳','💰','🎁','🚀',
  '☀️','🌙','🌈','🍀','🌹','🍕','☕','🍻',
];

export interface EmojiPickerProps {
  onPick: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onPick, onClose }: EmojiPickerProps) {
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      ref={rootRef}
      className="absolute bottom-full left-0 mb-1 bg-white border border-gray-200 rounded-md shadow-lg p-2 z-20"
      style={{ width: 232 }}
    >
      <div className="grid grid-cols-8 gap-1">
        {EMOJIS.map((e, i) => (
          <button
            key={`${e}-${i}`}
            type="button"
            onClick={() => onPick(e)}
            className="text-lg leading-none hover:bg-gray-100 rounded p-1"
            title={e}
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
